<template>
   <v-dialog
   v-model="openDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="title-card">
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.empresa.id"
                :items="getEmpresas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Empresas"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.obra.id"
                :items="getObras"
                :rules="nameRules"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.nfe"
                required
                :rules="nameRules"
                label="NFE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.data_vencimento"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de vencimento"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="3"
              sm="3"
              md="3"
            >
              <v-text-field
                v-model="obj.valor"
                required
                label="Valor"
                outlined
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="4"
              sm="4"
              md="4"
            >
              <v-select
                v-model="quantidadeParcelas"
                :items="listParcelas"
                :item-text="'descricao'"
                :item-value="'quantidade'"
                outlined
                label="Parcela"
              ></v-select>
            </v-col>
            <v-col
              cols="5"
              sm="5"
              md="5"
              class="mx-0 px-0 d-flex justify-center align-center font-weight-bold pb-6"
            >
              {{ `${quantidadeParcelas} parcela(s) de ${formatarMoedaBRL(obj.valor / quantidadeParcelas)} R$`}}
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive"
                label="Link GOOGLE DRIVE - NOTE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_boleto"
                label="Link GOOGLE DRIVE - BOLETO"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive_comprovante"
                label="Link GOOGLE DRIVE - COMPROVANTE"
                outlined
              ></v-text-field>
            </v-col>
            
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Arquivo - GOOGLE DRIVE - NOTA</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <a :href="obj.link_google_drive" target="_blank" disabled>Documento não cadastrado -  NFE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_boleto">
              <a :href="obj.link_google_drive_boleto" target="_blank">Arquivo - GOOGLE DRIVE - BOLETO</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <a :href="obj.link_google_drive_boleto" target="_blank" disabled>Documento não cadastrado -  BOLETO</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive_comprovante">
              <a :href="obj.link_google_drive_comprovante" target="_blank">Arquivo - GOOGLE DRIVE - COMPROVANTE</a>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-else>
              <a :href="obj.link_google_drive_comprovante" target="_blank" disabled>Documento não cadastrado -  COMPROVANTE</a>
            </v-col>
          </v-row>
         </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          dark
          :loading="loading"
          color="primary"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  currencyRules,
} from '@/validations';
export default {
  props:{
    openDialog: Boolean
  },
  data () {
      return {
      currencyRules,  
      valid:false,
      formTitle:'Novo cadastro',
      nameRules: [
        v => !!v || 'Campo requerido',
      ],
      quantidadeParcelas: 1,
      listParcelas:[
        {
          "quantidade": 1,
          "descricao": "1 vez"
        },
        {
          "quantidade": 2,
          "descricao": "2 vezes"
        },
        {
          "quantidade": 3,
          "descricao": "3 vezes"
        },
        {
          "quantidade": 4,
          "descricao": "4 vezes"
        },
        {
          "quantidade": 5,
          "descricao": "5 vezes"
        },
        {
          "quantidade": 6,
          "descricao": "6 vezes"
        },
        {
          "quantidade": 7,
          "descricao": "7 vezes"
        },
        {
          "quantidade": 8,
          "descricao": "8 vezes"
        },
        {
          "quantidade": 9,
          "descricao": "9 vezes"
        },
        {
          "quantidade": 10,
          "descricao": "10 vezes"
        },
        {
          "quantidade": 11,
          "descricao": "11 vezes"
        },
        {
          "quantidade": 12,
          "descricao": "12 vezes"
        },
        {
          "quantidade": 13,
          "descricao": "13 vezes"
        },
        {
          "quantidade": 14,
          "descricao": "14 vezes"
        },
        {
          "quantidade": 15,
          "descricao": "15 vezes"
        },
        {
          "quantidade": 16,
          "descricao": "16 vezes"
        },
        {
          "quantidade": 17,
          "descricao": "17 vezes"
        },
        {
          "quantidade": 18,
          "descricao": "18 vezes"
        },
        {
          "quantidade": 19,
          "descricao": "19 vezes"
        },
        {
          "quantidade": 20,
          "descricao": "20 vezes"
        },
        {
          "quantidade": 21,
          "descricao": "21 vezes"
        },
        {
          "quantidade": 22,
          "descricao": "22 vezes"
        },
        {
          "quantidade": 23,
          "descricao": "23 vezes"
        },
        {
          "quantidade": 24,
          "descricao": "24 vezes"
        },
        {
          "quantidade": 25,
          "descricao": "25 vezes"
        },
        {
          "quantidade": 26,
          "descricao": "26 vezes"
        },
        {
          "quantidade": 27,
          "descricao": "27 vezes"
        },
        {
          "quantidade": 28,
          "descricao": "28 vezes"
        },
        {
          "quantidade": 29,
          "descricao": "29 vezes"
        },
        {
          "quantidade": 30,
          "descricao": "30 vezes"
        },
        {
          "quantidade": 31,
          "descricao": "31 vezes"
        },
        {
          "quantidade": 32,
          "descricao": "32 vezes"
        },
        {
          "quantidade": 33,
          "descricao": "33 vezes"
        },
        {
          "quantidade": 34,
          "descricao": "34 vezes"
        },
        {
          "quantidade": 35,
          "descricao": "35 vezes"
        },
        {
          "quantidade": 36,
          "descricao": "36 vezes"
        },
        {
          "quantidade": 37,
          "descricao": "37 vezes"
        },
        {
          "quantidade": 38,
          "descricao": "38 vezes"
        },
        {
          "quantidade": 39,
          "descricao": "39 vezes"
        },
        {
          "quantidade": 40,
          "descricao": "40 vezes"
        },
        {
          "quantidade": 41,
          "descricao": "41 vezes"
        },
        {
          "quantidade": 42,
          "descricao": "42 vezes"
        },
        {
          "quantidade": 43,
          "descricao": "43 vezes"
        },
        {
          "quantidade": 44,
          "descricao": "44 vezes"
        },
        {
          "quantidade": 45,
          "descricao": "45 vezes"
        },
        {
          "quantidade": 46,
          "descricao": "46 vezes"
        },
        {
          "quantidade": 47,
          "descricao": "47 vezes"
        },
        {
          "quantidade": 48,
          "descricao": "48 vezes"
        }
      ],
      dialog: false,
      loading:false,
      obj: {
        empresa: {
          id: null
        },
        obra: {
          id: null
        },
        descricao: '',
        nome:'',
        data_vencimento:'',
        valor: 0,
        isPago: false
      },
      moneyOptions: {
        precision: 2,
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        allowNegative: false,
        defaultValue: '0'
      }
      }
    },
    computed:{
      ...mapGetters('empresa', {getEmpresas:'getList'}),
      ...mapGetters('obra', {getObras:'getList'}),
      customObj(){
        return {
          ...this.obj,
          empresa:{
                    id: this.obj.empresa.id,
                    nome: this.getEmpresas.find((item) => item.id === this.obj.empresa.id).nome
                  },
          obra:{
            ...this.getObras.find((item) => item.id === this.obj.obra.id)
          },        
          data_saida: this.obj.data_vencimento,
          pessoaManual: this.obj.descricao,
          data_vencimento_timestamp: this.formatToDatastamp(this.obj.data_vencimento)
        }
      }
    },
    methods: {
    ...mapActions('empresa', {getAllEmpresas:'getAllEmpresas'}),
    ...mapActions('boleto', ['saveBoleto']),
    formatarMoedaBRL(valor) {
      const formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
      return formatter.format(valor);
    },
    parseDateFromDDMMYYYY(dateString) {
      const [day, month, year] = dateString.split('/').map(Number);
      return new Date(year, month - 1, day); // Months are zero-indexed
    },
    formatDateToDDMMYYYY(date) {
      const day = String(date.getDate()).padStart(2, '0'); // Ensure day is always 2 digits
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed (0 = January)
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
    getSameDayAfterMonths(date, monthsToAdd) {
      const newDate = new Date(date);
      
      // Set the month to the new month based on the parameter
      newDate.setMonth(date.getMonth() + monthsToAdd);
      
      // Handle edge cases where the new month has fewer days
      if (newDate.getDate() !== date.getDate()) {
        newDate.setDate(0); // Set to the last day of the previous month
      }

      return newDate;
    },
    formatToDatastamp(dateStr){
            // Split the date string into parts
      const [day, month, year] = dateStr.split('/').map(Number);

      // Create a new Date object
      const dateObj = new Date(year, month - 1, day); // month - 1 because JavaScript months are 0-indexed

      // Convert to timestamp (milliseconds since Unix epoch)
      const timestamp = dateObj.getTime();
      return timestamp;
    },
    async save() {
        this.$refs.form.validate()
        /* eslint-disable no-console */
      if (this.valid) {
          try {
            for (let i = 0; i < this.quantidadeParcelas; i++) {
              const data_vencimento = (this.getSameDayAfterMonths(this.parseDateFromDDMMYYYY(this.obj.data_vencimento), i));
              const data_vencimento_timestamp = data_vencimento.getTime();
              const valor = this.formatarMoedaBRL(this.obj.valor / this.quantidadeParcelas).replace("R$","").trim().replace(".","").replace(",",".");
              const payload = {
                ...this.customObj,
                parcela: this.quantidadeParcelas === 1 ? 'Não houve parcelamento' : ((i + 1) + " parcela(s) de " + this.quantidadeParcelas),
                data_vencimento: this.formatDateToDDMMYYYY(data_vencimento),
                data_vencimento_timestamp,
                data_saida: this.formatDateToDDMMYYYY(data_vencimento),
                active: true,
                isPago: false,
                valor
              };
              await this.saveBoleto(payload)
            }
          } catch (error) {
              console.error(error);
          } finally {
              this.$emit('searchByFilter');
              this.closeModal();
          }
        }
      },
      closeModal () {
          this.$emit('closeModal')
      },
      reset(){
          this.$refs.form.reset()
      },
    watch:{
      openDialog(){
          this.reset();
      }
    }
  }
}
</script>
<style>
.v-main {
  width: 95% !important;
}
.menu {
  width: 100% !important;
  padding-top: 0px !important;
  z-index: 1;
  margin-top: 0px !important;
  position: inherit !important;
}
.btn-new{
  padding-top: 10px;
  justify-content: flex-end;
  display: flex;
}
.title-card{
  background: #0030b1 !important;
  color: white;
  padding: 20px !important;
}
.v-card__text {
  padding-top: 20px !important;
}
</style>
